import { DetectedEvent } from '@ais-ui/websockets';
import { useLocalization } from '@ais-ui/locale-management';
import { useDateTimeFormat } from '../conversions/useDateFormat';
import { useEventSeverity } from './useEventSeverity';
import { capitalize, cn, isNonEmpty } from '@ais-ui/utils';
import React from 'react';

import { EventGridItem } from './EventGridItem';

interface EventDetailsItemProps {
  event: DetectedEvent;
}

export const EventDetailsItem = ({ event }: EventDetailsItemProps) => {
  const { messages } = useLocalization();
  const { formatDateTimeWithTimeZone } = useDateTimeFormat();

  const severity = useEventSeverity(event);

  return (
    <div className="flex flex-col space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col gap-1">
          <p className="text-sm font-medium flex-none">
            {messages.eventsItemSeverityLabel}
          </p>
          <div className="flex items-center space-x-1.5">
            <div
              className={cn(
                'w-2 h-2 rounded-full',
                severity === 'note' && 'bg-blue-500',
                severity === 'warning' && 'bg-yellow-500',
                severity === 'alert' && 'bg-red-500'
              )}
            ></div>
            <p className="text-sm text-gray-500 dark:text-gray-400 flex-grow text-ellipsis overflow-hidden">
              {isNonEmpty(capitalize(severity))
                ? capitalize(severity)
                : 'Unknown'}
            </p>
          </div>
        </div>
        <EventGridItem
          label={messages.eventsItemDetectorLabel}
          value={event.name}
        />
      </div>
      <EventGridItem
        label={messages.eventsItemActivatedLabel}
        value={formatDateTimeWithTimeZone(event.activated)}
      />
      <EventGridItem
        label={messages.eventsItemDeactivatedLabel}
        value={
          formatDateTimeWithTimeZone(event.deactivated)
            ? formatDateTimeWithTimeZone(event.deactivated)
            : messages.eventsItemDeactivatedFalseValue
        }
      />
      <EventGridItem
        label={messages.eventsItemSubtypeLabel}
        value={event.subtype ? event.subtype : event.type}
      />
      <EventGridItem
        label={messages.eventsItemTextLabel}
        value={event.actText}
      />
    </div>
  );
};
